import AuthorsService from '@/common/API/AuthorsService';
import Toast from '@/common/Toast';
import { useData } from '@/common/hooks/useData';
import FormFactory from '@/components/FormFactory';
import Input from '@/components/forms/Input';
import Screen from '@/components/layout/Screen';
import { Button } from '@/components/ui/button';
import { Field } from 'formik';
import React, { MutableRefObject, useEffect, useRef } from 'react';
import { Params, useParams } from 'react-router';

const AuthorsEditScreen = () => {
  const formRef: MutableRefObject<any> = useRef();
  const { id }: { id?: Readonly<Params<string>> } = useParams();
  const { fetchAuthors } = useData();

  useEffect(() => {
    AuthorsService.one(id).then((res) => {
      formRef.current.setValues(res.data);
    });
  }, []);

  return (
    <Screen
      screenContainerClassName='bg-black'
      screenOptions={{
        header: {
          title: 'Edit author',
          backBtnLabel: 'Authors',
          backBtnUrl: '/authors',
          titleClassName: 'text-white',
        },
      }}
      className='px-4 grid grid-rows-5'
    >
      <FormFactory className='row-span-4' formRef={formRef} initialValues={{ name: '' }}>
        <Field name='name' placeholder='Author name' component={Input} />
      </FormFactory>
      <div className='flex items-end'>
        <Button
          onClick={() => {
            AuthorsService.update(id, formRef.current.values).then((res: any) => {
              fetchAuthors();
              Toast.success(res?.message);
            });
          }}
          className='w-full mt-4'
        >
          Save
        </Button>
      </div>
    </Screen>
  );
};

export default AuthorsEditScreen;
